export default "../../src/img/angle.svg";